/*
 * @Author: Long
 * @Date: 2021-05-06 18:00:09
 * @LastEditors: Long
 * @LastEditTime: 2022-02-16 14:25:32
 */
const service = require('@/assets/js/request')

class message {
  /**
   * 修改用户信息
   */
  static updateUserInfo (target) {
    service.request({
      method: 'POST',
      url: 'updateUserInfo',
      params: {
        avatars: target.ruleForm.cover,
        name1: target.ruleForm.name1,
        niceName: target.ruleForm.niceName,
        phone: target.ruleForm.phone
      }
    }).then(res => {
      if (res.code === '2001') {
        target.$message({
          message: res.msg,
          type: 'success'
        })
      } else {
        target.$message({
          message: res.msg,
          type: 'warning'
        })
      }
    }).catch(err => {
      service.error(err, {
        that: target
      })
    })
  }
}

export default message



// WEBPACK FOOTER //
// ./src/components/customer/message/message.js